import { render, staticRenderFns } from "./DeleteHospital.vue?vue&type=template&id=75c716ad&scoped=true"
import script from "./DeleteHospital.vue?vue&type=script&lang=js"
export * from "./DeleteHospital.vue?vue&type=script&lang=js"
import style0 from "./DeleteHospital.vue?vue&type=style&index=0&id=75c716ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c716ad",
  null
  
)

export default component.exports